(function(){
  var lastFocus=null, openId=null, quizA=null;
  function el(id){return document.getElementById(id)}
  function anyOpen(){return !!openId}
  function open(id){
    if(openId===id) return;
    if(openId) closeNow(openId);
    var o=el(id); if(!o) return;
    lastFocus=document.activeElement;
    o.hidden=false; openId=id;
    document.body.style.overflow='hidden';
    requestAnimationFrame(function(){o.classList.add('open')});
    try{sessionStorage.setItem('sacraPop','1')}catch(e){}
    if(id==='popA'){ if(!quizA){ quizA=SacraQuiz.mount(el('quizA'),{utm:state.utm}); } else quizA.setUTM(state.utm); }
    if(id==='popB') game.reset();
    if(window.Shopify&&Shopify.analytics) try{Shopify.analytics.publish('popup_open',{popup:id})}catch(e){}
    var f=o.querySelector('.pane.on button, .pane.on a, .close'); if(f) setTimeout(function(){f.focus()},80);
  }
  function closeNow(id){var o=el(id); o.classList.remove('open'); o.hidden=true; if(openId===id) openId=null; document.body.style.overflow=''; if(id==='popB') game.stop();}
  function close(id){
    var o=el(id); if(!o||o.hidden) return;
    o.classList.remove('open');
    setTimeout(function(){o.hidden=true; if(openId===id) openId=null; document.body.style.overflow=''; if(lastFocus&&lastFocus.focus) lastFocus.focus()},350);
    if(id==='popB') game.stop();
  }
  document.addEventListener('click',function(e){
    var c=e.target.closest('[data-close]'); if(c){close(c.dataset.close)}
    var p=e.target.closest('[data-pop]'); if(p){e.preventDefault();open(p.dataset.pop)}
    if(e.target.classList&&e.target.classList.contains('sac-overlay')) close(e.target.id);
    var a=e.target.closest('.sac-overlay a[href]'); if(a&&openId) close(openId);
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&openId) close(openId)});
  document.addEventListener('submit',function(e){
    var f=e.target; if(!f.matches('form[data-email]')) return;
    e.preventDefault(); var i=f.querySelector('input'); var v=(i.value||'').trim();
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)){i.focus();i.setAttribute('aria-invalid','true');return}
    i.removeAttribute('aria-invalid'); i.value='';
    if(window.sacraSubscribe) window.sacraSubscribe(v, f.dataset.email==='plan'?'quiz-plan':'quiz-result', f.dataset.props?JSON.parse(f.dataset.props):{});
    window.toast(f.dataset.email==='plan'?'28-day ritual sent to '+v:'Your ritual is on its way to '+v);
    if(openId) close(openId);
  });
  var state={utm:false};
  try{ var u=new URLSearchParams(location.search).get('utm_content')||''; if(/react|sensitiv/i.test(u)) state.utm=true; }catch(e){}

  /* ---------- Pop-up B: Rebuild your barrier ---------- */
  var game=(function(){
    var canvas=el('wall'); if(!canvas) return {reset:function(){},stop:function(){},start:function(){}};
    var ctx=canvas.getContext('2d');
    var W=464,H=248,m=8,bh=40,bw=68,rows=5,dpr=Math.min(2,window.devicePixelRatio||1);
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var bricks=[],flying=[],raf=null,running=false,t0=0,last=0,spawnAt=0,sumInt=0,samples=0;
    var LABELS=['SUN','TRAVEL','EXERCISE','CLIMATE'];
    var C={mortar:'#C96947',brick:'#E4D6C3',brickPale:'#F2EAE1',gone:'#EDE3D7'};
    canvas.width=W*dpr; canvas.height=H*dpr; ctx.setTransform(dpr,0,0,dpr,0,0);
    function build(){
      bricks=[];
      for(var r=0;r<rows;r++){
        var y=m+r*(bh+m), off=(r%2)?-(bw+m)/2:0;
        for(var i=0;i<8;i++){
          var x=m+off+i*(bw+m), x0=Math.max(m,x), x1=Math.min(W-m,x+bw);
          if(x1-x0<18) continue;
          bricks.push({x:x0,y:y,w:x1-x0,h:bh,sealed:true,targeted:false,flash:0,drops:[]});
        }
      }
    }
    function pane(name){document.querySelectorAll('#popB .pane').forEach(function(p){p.classList.toggle('on',p.dataset.g===name)})}
    function reset(){stop(); build(); flying=[]; pane('intro'); draw();}
    function start(){ build(); flying=[]; sumInt=0; samples=0; running=true; t0=performance.now(); last=t0; spawnAt=t0+700; pane('play'); loop(t0); }
    function stop(){running=false; if(raf) cancelAnimationFrame(raf); raf=null;}
    function integrity(){var s=0; bricks.forEach(function(b){if(b.sealed)s++}); return s/bricks.length}
    function spawn(){
      var pool=bricks.filter(function(b){return b.sealed&&!b.targeted}); if(!pool.length) return;
      var b=pool[Math.floor(Math.random()*pool.length)]; b.targeted=true;
      flying.push({label:LABELS[Math.floor(Math.random()*LABELS.length)],x:b.x+b.w/2,ty:b.y+b.h/2,t:reduce?1:0,b:b});
    }
    function erode(b){ b.sealed=false; b.targeted=false; for(var i=0;i<3;i++) b.drops.push({x:b.x+8+Math.random()*(b.w-16),y:b.y+4,v:14+Math.random()*16,a:1}); }
    function loop(now){
      if(!running) return;
      var dt=Math.min(50,now-last); last=now; var el_=now-t0; var progress=Math.min(1,el_/20000);
      var interval=1100-520*progress;
      if(now>=spawnAt){spawn(); spawnAt=now+interval;}
      flying.forEach(function(f){ f.t+=dt/620; if(f.t>=1&&!f.done){f.done=true; erode(f.b);} });
      flying=flying.filter(function(f){return f.t<1.35});
      bricks.forEach(function(b){ if(b.flash>0)b.flash=Math.max(0,b.flash-dt/380); b.drops.forEach(function(d){d.y-=d.v*dt/1000; d.a-=dt/1400}); b.drops=b.drops.filter(function(d){return d.a>0}); });
      var integ=integrity(); sumInt+=integ; samples++;
      el('gInt').textContent=Math.round(integ*100)+'%';
      el('gTime').textContent=Math.max(0,Math.ceil((20000-el_)/1000));
      el('gBar').style.transform='scaleX('+(1-progress)+')';
      draw();
      if(el_>=20000){ finish(); return; }
      raf=requestAnimationFrame(loop);
    }
    function draw(){
      ctx.clearRect(0,0,W,H);
      ctx.fillStyle=C.mortar; ctx.fillRect(m/2,m/2,W-m,H-m);
      bricks.forEach(function(b){ if(!b.sealed){ ctx.fillStyle=C.gone; var x0=Math.max(m/2,b.x-m),y0=Math.max(m/2,b.y-m); ctx.fillRect(x0,y0,Math.min(W-m/2,b.x+b.w+m)-x0,Math.min(H-m/2,b.y+b.h+m)-y0); } });
      bricks.forEach(function(b){
        ctx.fillStyle=b.sealed?C.brick:C.brickPale; ctx.fillRect(b.x,b.y,b.w,b.h);
        if(b.flash>0){ ctx.fillStyle='rgba(201,105,71,'+(0.55*b.flash)+')'; ctx.fillRect(b.x,b.y,b.w,b.h); }
        b.drops.forEach(function(d){ ctx.fillStyle='rgba(42,26,18,'+(0.35*d.a)+')'; ctx.beginPath(); ctx.arc(d.x,d.y,2.2,0,Math.PI*2); ctx.fill(); });
      });
      ctx.font='500 10px Jost, Futura, "Century Gothic", sans-serif'; ctx.textAlign='center'; ctx.textBaseline='middle';
      flying.forEach(function(f){
        var e=f.t<1?(f.t*f.t):1; var y=-14+(f.ty+14)*e; var a=f.t<1?1:Math.max(0,1-(f.t-1)/0.35);
        ctx.fillStyle='rgba(42,26,18,'+a+')'; var w=ctx.measureText(f.label).width+18; ctx.fillRect(f.x-w/2,y-9,w,18);
        ctx.fillStyle='rgba(242,234,225,'+a+')'; ctx.fillText(f.label.split('').join(String.fromCharCode(8202)),f.x,y+0.5);
      });
    }
    function tap(e){
      if(!running) return;
      var r=canvas.getBoundingClientRect(); var px=(e.clientX-r.left)*W/r.width, py=(e.clientY-r.top)*H/r.height;
      for(var i=0;i<bricks.length;i++){ var b=bricks[i];
        if(px>=b.x-m/2&&px<=b.x+b.w+m/2&&py>=b.y-m/2&&py<=b.y+b.h+m/2){ if(!b.sealed){b.sealed=true;b.flash=1;b.drops=[];} break; }
      }
    }
    canvas.addEventListener('pointerdown',function(e){e.preventDefault();tap(e)});
    function finish(){
      running=false; if(raf) cancelAnimationFrame(raf); raf=null;
      var score=Math.round((sumInt/Math.max(1,samples))*100);
      var tier,head,copy;
      if(score>=85){tier='Barrier rebuilt';head='Quick hands.';copy='Your skin needs the same reflex every evening: lipids back before the water leaves. That is the serum’s whole job.';}
      else if(score>=55){tier='Half rescued';head='That is most skin after a summer.';copy='Some mortar back, some still missing. Tightness by midday is the sign. The serum finishes what your fingertips started.';}
      else{tier='Depleted';head='That is a flight, a run and a beach day, without help.';copy='Water escapes through a wall like this one all night long. Here is the rescue, in the order to use it.';}
      el('gTier').textContent=tier; el('gScore').textContent=score+'%'; el('gHead').textContent=head; el('gCopy').textContent=copy;
      pane('end'); el('popB').querySelector('.sheet').scrollTop=0;
      if(window.Shopify&&Shopify.analytics) try{Shopify.analytics.publish('game_complete',{score:score,tier:tier})}catch(e){}
    }
    document.querySelector('[data-g-start]').addEventListener('click',start);
    document.querySelector('[data-g-again]').addEventListener('click',start);
    document.querySelector('[data-g-skip]').addEventListener('click',function(){close('popB'); setTimeout(function(){open('popA')},380)});
    build(); draw();
    return {reset:reset,stop:stop,start:start};
  })();

  /* ---------- triggers (homepage only, once per session) ---------- */
  var shown=false; try{shown=sessionStorage.getItem('sacraPop')==='1'}catch(e){}
  function onHome(){return document.body.getAttribute('data-template')==='index'}
  function auto(){ if(shown||anyOpen()||!onHome()) return; shown=true; open('popA'); }
  if(window.Shopify&&Shopify.designMode){ shown=true; }
  if(state.utm){ setTimeout(function(){ if(!anyOpen()) open('popA'); },1200); shown=true; }
  else if(!shown){
    setTimeout(auto,15000);
    var mech=el('mechanism');
    if(mech&&'IntersectionObserver' in window){ var io=new IntersectionObserver(function(en){ if(en[0].isIntersecting){auto(); io.disconnect();} },{threshold:.2}); io.observe(mech); }
    document.addEventListener('mouseleave',function(e){ if(e.clientY<=0 && document.body.getAttribute('data-template')==='product' && !shown){ shown=true; open('popA'); } });
  }
  window.sacraPopups={open:open,close:close};
})();
